import { getFavDynamicTemplateList } from "../../api/templateApi";
import { FORMS, MODULES } from "../../const";
import { favTemplateCreationIcon } from "./icon/ChargeConfirmationIcon";
import sidebarData from "./sidebarData";

const FAVORITES_GROUP_LABEL = "Favorite Templates";

export async function initSidebarFavorites() {
  try {
    const favTemplates = await getFavDynamicTemplateList();
    const list = Array.isArray(favTemplates) ? favTemplates : [];

    // find the existing Favorites group you already added under Fleet
    const group = sidebarData.Fleet?.find(
      (x) => x?.className === "SubHeader" && x?.label === FAVORITES_GROUP_LABEL,
    );

    if (!group) return; // safety

    group.items = list.map((t) => ({
      label: t.dyhTemplate ?? "Template",
      description: t.dyhTemplate ?? "",
      module: MODULES.Fleet,
      form: FORMS.FLEET_INSPECTION.INSPECTION_PROCESS.form,
      icon: favTemplateCreationIcon,
      linkName: `/fleet/inspection-create?dyhId=${t.fdhDyhId}`,
    }));
  } catch (e) {
    console.error("Failed to init favorites", e);
  }
}
